import { render, staticRenderFns } from "./ALabel.vue?vue&type=template&id=169c008c"
import script from "./ALabel.vue?vue&type=script&lang=ts"
export * from "./ALabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports